import { render, staticRenderFns } from "./IncidentForm.vue?vue&type=template&id=40ffe608&scoped=true"
import script from "./IncidentForm.vue?vue&type=script&lang=js"
export * from "./IncidentForm.vue?vue&type=script&lang=js"
import style0 from "./IncidentForm.vue?vue&type=style&index=0&id=40ffe608&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ffe608",
  null
  
)

export default component.exports